import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { ChevronRight, Settings } from 'lucide-react';
import { useAppCtx, appStore } from 'lib/state';
import { queryTools, cn } from 'lib/utils';
import { ELEMENTS } from "lib/utils/CONSTANTS"
import { Dropdown, ElementModsDisplay } from "lib/components"
import * as Elements from "lib/units/element"


function Placeholder({ className="", ...rest }:{ className?:string; [key:string]:any }){
  return (
    <div 
      {...rest}
      className={cn(
        "w-full bg-transparent border border-solid border-slate-700 relative cursor-pointer hover:border-white/80",
        className
      )}>
        <span className="absolute top-2 left-2 text-xs uppercase text-white/70">{rest.title}</span>
    </div>
  )
}


export default function TemplateWireframe(){

  const { tmplid } = useParams()
  const [ searchParams, setSearchParams ] = useSearchParams()

  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()

  const { update } = AppStore

  const [ selectedElement, setSelectedElement ] = useState<any>()
  const [ selectedEditor, setSelectedEditor ] = useState<any>({ refstr: null, property: "", title: ""})
  const [ selectedTarget, setSelectedTarget ] = useState<any>({ template: "", subdomain: "", rp: ""})
  
  const { data:_Template } = queryTools.resource.parseQueryForApi("template.findById", { _id: tmplid })
  const { data:_Clients } = queryTools.resource.parseQueryForApi("client.findAll", {})

  const customFilters = { template: selectedTarget?.template, element: selectedElement?.refstr, subdomain: selectedTarget?.subdomain, rp: selectedTarget?.rp, refstr: selectedEditor?.refstr}
  const { data:_Customizations } = queryTools.resource.parseQueryForApi("customization.findAll", customFilters)

  // const { data:_Customizations } = queryTools.resource.getCollection({ resource: "customization", modifier: `${selectedTarget?.template}-${selectedTarget?.subdomain}-${selectedTarget?.rp}-${selectedEditor?.refstr}`, params: { template: selectedTarget?.template, element: selectedElement?.refstr, subdomain: selectedTarget?.subdomain, rp: selectedTarget?.rp, refstr: selectedEditor?.refstr } })

  const getElement = (refstr:string) => ELEMENTS.find( (el:any) => el.refstr === refstr )

  const openEditor = (refstr:string) => {
    setSearchParams({ elem: refstr })
    update("actives.element", { refstr }) 
  }

  const getInlineEditors = () => selectedElement?.editors.filter((editor:any) => editor.type === "inline")

  const handlePhClick = (refstr:string) => {
    const elem = getElement(refstr)
    setSelectedElement(elem)
  }

  const getCombinedClientLabel = (client:any) => (!client) ? "" : `${client?.name} (${client?.subdomain})`

  useEffect(() => {
    if( selectedEditor.refstr !== null ){
      const editor = selectedElement?.editors.find((editor:any) => editor.refstr === selectedEditor.refstr)
      setSelectedEditor((prev:any) => ({ ...prev, ...editor }))
    }
  },[selectedEditor.refstr])

  useEffect(() => {
    console.log(selectedTarget)
  },[selectedTarget])

  useEffect(() => {
    console.log(_Customizations)
  },[_Customizations])

  return (
    <div 
      // onClick={() => update("_metas.viewmode", "build")}
      className={cn(
        "w-full flex flex-col mt-2 px-3 py-3 gap-2 relative overflow-hidden",
        store.metas.viewmode === "testing" && "mt-4 pt-8 border-yellow-500/70"
      )}
    >

      { store.metas.viewmode === "testing" && (
        <div className="absolute top-[-.8rem] left-0 right-0 mx-auto w-3/12 border border-solid border-yellow-500/70 bg-slate-700 flex justify-center items-center h-6 text-xs uppercase cursor-pointer">exit test mode</div>
      )}

      <div className="w-full flex justify-start items-start gap-8">

        <div className="w-7/12 flex flex-col gap-2">
          <Placeholder {...getElement("topbar")} onClick={() => handlePhClick("topbar")} className="w-full h-8" />
          <div className="w-full flex gap-4">
            <div className="w-6/12 flex flex-col gap-2">
              <Placeholder {...getElement("title_block")} onClick={() => handlePhClick("title_block")} className="w-full h-12" />
              <Placeholder {...getElement("summary_table")} onClick={() => handlePhClick("summary_table")} className="w-full h-16" />
            </div>
            <div className="w-6/12 flex flex-col gap-2">
              <Placeholder {...getElement("mm_logo")} onClick={() => handlePhClick("mm_logo")} className="w-full h-10" />
              <Placeholder {...getElement("summary_block")} onClick={() => handlePhClick("summary_block")} className="w-full h-12" />
            </div>
          </div>

          <Placeholder {...getElement("letter_prefix")} onClick={() => handlePhClick("letter_prefix")} className="w-full h-8" />
          <Placeholder {...getElement("opening_statements")} onClick={() => handlePhClick("opening_statements")} className="w-full h-16" />
          <Placeholder {...getElement("trx_history")} onClick={() => handlePhClick("trx_history")} className="w-full h-10" />
          <Placeholder {...getElement("supporting_images")} onClick={() => handlePhClick("supporting_images")} className="w-full h-20" />
          <Placeholder {...getElement("compelling_evidence")} onClick={() => handlePhClick("compelling_evidence")} className="w-full h-16" />
          <Placeholder {...getElement("detail_screens")} onClick={() => handlePhClick("detail_screens")} className="w-full h-20" />
          <Placeholder {...getElement("policies")} onClick={() => handlePhClick("policies")} className="w-full h-16" />
          <Placeholder {...getElement("letter_closing")} onClick={() => handlePhClick("letter_closing")} className="w-full h-8" />
          <Placeholder {...getElement("disclaimer")} onClick={() => handlePhClick("disclaimer")} className="w-full h-8" />
        </div>

        <div className="w-5/12 flex flex-col gap-2">
          { selectedElement !== undefined && (
            <div className="w-full flex flex-col">
              <div className="w-full flex justify-between items-center py-1 px-2 mb-5 border-y border-solid border-slate-700">
                <h2 className="w-10/12 text-lg font-bold uppercase">
                  { selectedElement?.title }
                </h2>
                {/* <Settings className="w-5 h-5 stroke-1 cursor-pointer" onClick={() => openEditor(selectedElement.refstr)} /> */}
              </div>
              <p className="px-2">{selectedElement.description}</p>
              
              { selectedElement.editors.find((editor:any) => editor.type === "refstr-link") && (
                <p className="px-2 mt-4 text-yellow-500 cursor-pointer" onClick={() => openEditor(selectedElement.refstr)}>
                  Open the editing tool
                </p>
              )}

              { getInlineEditors().length > 0 && (
                <>
                  <div className="w-full flex flex-col px-2 mt-3">
                    <p>Choose an editor below:</p>
                    <div className="w-full flex justify-start items-start gap-2 mt-3 px-1">
                      <Dropdown
                        className="w-4/12"
                        title="Choose an Editor"
                        items={getInlineEditors().map((editor:any) => ({ label: editor.title, value: editor.refstr }))}
                        selected={getInlineEditors().find((editor:any) => editor.refstr === selectedEditor.refstr)?.title || ""}
                        selectFn={(item:any) => {
                          console.log(item)
                          setSelectedEditor((prev:any) => ({ ...prev, refstr:item.value }))} 
                        }
                      />
                      <Dropdown
                        className="w-5/12"
                        title="Choose a Subdomain"
                        items={_Clients?.map((client:any) => ({ label: getCombinedClientLabel(client), value: client.subdomain }))}
                        selected={ getCombinedClientLabel(_Clients?.find((client:any) => client.subdomain === selectedTarget.subdomain)) || ""}
                        selectFn={(item:any) => {
                          console.log(item)
                          setSelectedTarget((prev:any) => ({ ...prev, subdomain: item.value }))} 
                        }
                      />

                      <input
                        type="text" 
                        name="rp" 
                        value={selectedTarget.rp || ""}
                        onChange={(e:any) => setSelectedTarget((prev:any) => ({ ...prev, rp: e.target.value }))}
                        className="w-3/12 h-8 px-2 border border-solid border-slate-700 bg-transparent text-neutral-200"
                        placeholder="rp"
                      />

                      <button className="w-1/12 h-8 border border-solid border-teal-900 bg-teal-900 rounded flex justify-center items-center">
                        <ChevronRight 
                          onClick={() => setSelectedTarget((prev:any) => ({ ...prev, template: _Template._id }))}
                          className="w-4 h-4 stroke-1 text-neutral-200" 
                        />
                      </button>
                    </div>
                  </div>

                  { selectedTarget.template.length > 0 && selectedTarget.subdomain.length > 0 && selectedTarget.rp.length > 0 && selectedEditor.refstr.length > 0 && (
                    <div className="w-full flex flex-col gap-2 mt-4 px-2">
                      <label className="text-xs uppercase text-white/70">{ selectedEditor.title }</label>
                      { selectedEditor.uses === "input" && (
                        <input type="text" name="editing-value" className="w-full h-8 px-2 bg-transparent text-sm border border-solid border-slate-700 rounded focus:outline-0" />
                      )}
                      <button className="w-full h-6 text-sm uppercase text-neutral-200 bg-teal-800 rounded">Save</button>
                    </div>
                  ) }
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}